import { urlPathname } from './shared/utils';
import { mainaka } from './mainaka';
import { mainkurz } from './mainkurz';
import { mainkurzy } from './mainkurzy';
import { mainlektor } from './mainlektor';
import { mainlektori } from './mainlektori';
import { mainkosik } from './mainkosik';
import { mainobjednavka } from './mainobjednavka';
import { mainakaprofile } from './mainakaprofile';
import { mainostatni } from './mainostatni';
import { mainnakup } from './mainnakup';
import { mainfinal } from './mainfinal';
import { bindLoginHandler } from './login';
import { bindBlink } from './bracketblink';

import { Window } from './shared/akatypes';

declare const window: Window;

const jQuery = window.jQuery;

jQuery(document).ready(function () {
  console.log('pathname:"' + urlPathname() + '"');
  if (urlPathname().includes('index.php') || urlPathname().endsWith('/')) {
    console.log('index.php');
    mainaka();
  } else if (urlPathname().includes('kurz.php')) {
    console.log('kurz.php');
    mainkurz();
  } else if (urlPathname().includes('kurzy.php')) {
    console.log('kurzy.php');
    mainkurzy();
  } else if (urlPathname().includes('lektor.php')) {
    console.log('lektor.php');
    mainlektor();
  } else if (urlPathname().includes('lektori.php')) {
    console.log('lektori.php');
    mainlektori();
  } else if (urlPathname().includes('kosik.php')) {
    console.log('kosik.php');
    mainkosik();
  } else if (urlPathname().includes('objednavka.php')) {
    console.log('objednavka.php');
    mainobjednavka();
  } else if (urlPathname().includes('akaprofile.php')) {
    console.log('akaprofile.php');
    mainakaprofile();
  } else if (urlPathname().includes('nakup.php')) {
    console.log('nakup.php');
    mainnakup();
  } else if (urlPathname().includes('final.php')) {
    console.log('final.php');
    mainfinal();
  } else if (
    urlPathname().includes('dalsisluzby.php') ||
    urlPathname().includes('kontakt.php') ||
    urlPathname().includes('euedu.php') ||
    urlPathname().includes('euedudetail.php') ||
    urlPathname().includes('vzdelavacividea.php') ||
    urlPathname().includes('vzdelavacivideadetail.php')
  ) {
    console.log('ostatni');
    mainostatni();
  }
  bindLoginHandler();

  console.log('toto generuji z typescriptu');
});

// bracket blinking
// bindBlink();
